module.exports = __webpack_public_path__ + "img/bookmark-white.af12fdf7.png";